import { ExternalHyperlink, Paragraph, TextRun } from 'docx';

// Utils
import { getSocialMediaIdentifier } from '@/utils/pdf';
import { buildIconPrefix, dividerParagraph } from '../../utils';

// Types
import { type IconBuffers } from '@/components/template/resume/utils/icons';

// Constants
import { FONT_FAMILY, FONT_SIZES, SPACINGS } from '../../constants';

type SocialLink = {
  id?: string | null;
  name?: string | null;
  url?: string | null;
};

/** Creates the sidebar social links section from a link array */
export const SocialLinksSection = (
  links: SocialLink[],
  socialIcons: IconBuffers,
): Paragraph[] => {
  if (!links.length) return [];

  const items: Paragraph[] = [dividerParagraph()];

  for (const { url = '', name = '' } of links) {
    if (!url) continue;

    const identifier = getSocialMediaIdentifier(url);
    const displayText = identifier || url;

    // Lookup icon by URL then name then DEFAULT
    const iconData = socialIcons.lookup(url) ?? socialIcons.lookup(name ?? '');

    items.push(
      new Paragraph({
        spacing: { before: SPACINGS.socialBefore },
        children: [
          ...buildIconPrefix(iconData),
          new ExternalHyperlink({
            link: url,
            children: [
              new TextRun({
                text: displayText,
                font: FONT_FAMILY,
                size: FONT_SIZES.lg,
                underline: {},
              }),
            ],
          }),
        ],
      }),
    );
  }

  return items;
};
